<template>
  <div class="survey-loading-container is-centered">
    <div class="loading-gif-wrapper">
      <img src="@/assets/logo.gif" alt="Cargando..." class="loading-gif" />
    </div>
    <div class="loading-text has-text-centered">
      <h2 class="title is-spaced is-4 has-text-weight-semibold mb-2">
        Cargando encuesta...
      </h2>
      <p class="subtitle is-6 has-text-grey">
        Por favor espera mientras preparamos tu encuesta
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyLoading",
};
</script>

<style scoped>
.survey-loading-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #ffff;
  align-content: center;
  flex-wrap: wrap;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1.5rem;
}

.loading-gif-wrapper {
  margin-bottom: 1.5rem;
}

.loading-gif {
  width: 120px;
  height: 120px;
  object-fit: contain;
  display: block;
}

.loading-text {
  max-width: 500px;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .loading-content {
    padding: 3rem 1rem;
  }

  .loading-gif {
    width: 100px;
    height: 100px;
  }

  .title.is-4 {
    font-size: 1.25rem;
  }
}

/* Animación opcional para el contenedor */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.3s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/components/SurveyLoading.vue